import { uniq, filter, sumBy } from "lodash";

export const formatRadarTextLabel = (text: string | undefined): string => {
  const elipsisBreak = "...";
  const limitBeforeEllipsis = 30;
  
  if (text === undefined) return "";
  else if (text.length <= limitBeforeEllipsis) return text;
  
  const firstCharacter = text.substring(0, limitBeforeEllipsis);
  const textWithEllipsis = `${firstCharacter}${elipsisBreak}`;
  return textWithEllipsis;
};

/* in case of multiple groupBy, make second groupBy as chart valueDataSeries */
export function transformSecondGroupByToData(
  valueData: string[],
  groupByKeys: string | string[],
  data: any[]
): any[] {
  const isNotAnArray = !Array.isArray(groupByKeys);
  const haveOneGroupBy = Array.isArray(groupByKeys) && groupByKeys.length == 1;
  const haveMultipleValueData = Array.isArray(valueData) && valueData.length > 1;
  
  if (isNotAnArray || haveOneGroupBy || haveMultipleValueData) {
    return data;
  }
  
  const categoryData = groupByKeys[0];
  const categoryDataKeys = uniq(data.map((item) => item[categoryData]));

  const newValue = groupByKeys[1];
  const newValueKeys = uniq(data.map((item) => item[newValue]));

  // if no groupBy
  if (newValueKeys.length === 1 && newValueKeys[0] === undefined) {
    return data;
  }

  const newData = categoryDataKeys.map((categoryKey) => {
    const filtered = filter(data, { [categoryData]: categoryKey });

    const objectToReturn: any = {
      [categoryData]: categoryKey,
    };
    
    newValueKeys.forEach((key) => {
      const category = filter(filtered, { [newValue]: key });
      const sum = sumBy(category, (e) => e[valueData[0]]);
      objectToReturn[key] = sum;
    });

    return objectToReturn;
  });

  return newData;
}

/* in case of multiple groupBy, make second groupBy as chart valueData */
export function getValueData(
  valueData: string[],
  groupByKeys: string | string[],
  data: any[]
): string[] {
  const isNotAnArray = !Array.isArray(groupByKeys);
  const haveOneGroupBy = Array.isArray(groupByKeys) && groupByKeys.length == 1;
  const haveMultipleValueData = Array.isArray(valueData) && valueData.length > 1;
  
  if (isNotAnArray || haveOneGroupBy || haveMultipleValueData) {
    return valueData;
  }

  const newValue = groupByKeys[1];
  const newValueData = uniq(data.map((item) => item[newValue]));

  // if no valueData
  if (newValueData.length === 1 && newValueData[0] === undefined) {
    return valueData;
  }

  return newValueData;
}
